import {createStateSyncMiddleware, Config} from 'redux-state-sync'
import {REDUX_STATE_SYNC_CONFIG} from 'consts'
import {ReduxFullKey} from './ReduxReducer'

export interface ReduxSyncOptions extends Omit<Config, 'predicate'> {
  blacklist?: ReduxFullKey[]
  whitelist?: ReduxFullKey[]
}

const middlewareStateSync = createStateSyncMiddleware({
  ...REDUX_STATE_SYNC_CONFIG,
  whitelist: undefined,
  blacklist: undefined,
  predicate: (action) => {
    const {blacklist, whitelist} = REDUX_STATE_SYNC_CONFIG

    if (blacklist) return !blacklist.includes(action.key)
    if (whitelist) return whitelist.includes(action.key)

    return false
  },
})

export const REDUX_MIDDLEWARE = [middlewareStateSync]
